import { Log, Level, Logger } from 'ng2-logger';
import ApiClient from './alms-api';
import { Notification } from '../components/notification/main';
import Translator from '../core/i18n';

const T = Translator.create();
let _apiClient: ApiClient;
const token: any = localStorage.getItem('access_token');
const _logger = Log.create('Document-Service');

export class DocumentService {

    constructor() {
        _apiClient = new ApiClient();
    }

    // Get Lesson-Page Header Information
    public async RequestAddDocumentActivityAsync(params: any) {
        let setUrl = 'api/document/add';
  
        if(params.DocumentData.activityId) {
            setUrl = 'api/document/edit';
        }
        return _apiClient.RequestAsync('POST', setUrl, params.DocumentData).then((responseData: Response) => {
                return responseData;
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }

    public async RequestGetDocumentAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/activity/activitylist', params)
        .then((responseData: Response) => {
            return responseData;
        })
        .then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }

    // Get Assignement Activity Datas
    public async RequestGetUpdateDocumentActivity(params: any) {
       
        return _apiClient.RequestAsync('POST', 'api/document/get', params).then((responseData: Response) => {
            if(responseData.status !== 200) {
                responseData.text().then((data) => {
                    Notification.setNotification('error', T.t(data), 'topRight');
                }).catch();
                return null;
            } else {
                return responseData.json();
            }
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return false;
        });
    }

    // Get Lesson-Page Header Information
    public async RequestDeleteDocumentActivityAsync(params: any) {

        return _apiClient.RequestAsync('POST', 'api/document/delete', params.DocumentData, token).then((responseData: Response) => {
            if (responseData.status !== 200) {
                Notification.setNotification('error', T.t('r_course_page_lessonHeaderInfo_error_message'), 'topRight');
                return null;
            } else {
                return responseData.json();
            }
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            Notification.setNotification('error', T.t('r_course_page_lessonHeaderInfo_error_message'), 'topRight');
            return false;
        });
    }

    async RequestSaveDocumentPdfPage(params: any) {

        return _apiClient.RequestAsync('POST', 'api/document/pdfTracking', params, token).then((responseData: Response) => {
            if (responseData.status !== 200) {
                return null;
            } else {
                return responseData.json();
            }
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            Notification.setNotification('error', T.t('r_course_page_lessonHeaderInfo_error_message'), 'topRight');
            return false;
        });
    }
}

